import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle, ArrowRight, EnvelopeSimple } from "@phosphor-icons/react";

export const PaymentSuccess = ({ redirectUrl, buyerName, seconds = 4 }) => {
  const [left, setLeft] = useState(seconds);
  const first = (buyerName || "").trim().split(" ")[0];

  useEffect(() => {
    if (!redirectUrl) return undefined;
    if (left <= 0) {
      window.location.assign(redirectUrl);
      return undefined;
    }
    const t = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [left, redirectUrl]);

  return (
    <div className="text-center py-2" data-testid="payment-success-banner">
      <div className="relative mx-auto w-24 h-24">
        <motion.span
          className="absolute inset-0 rounded-full bg-emerald-500/25"
          animate={{ scale: [0.7, 1.7], opacity: [0.7, 0] }}
          transition={{ duration: 1.7, repeat: Infinity, ease: "easeOut" }}
        />
        <motion.div
          initial={{ scale: 0, rotate: -40 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 15 }}
          className="relative w-24 h-24 rounded-full bg-gradient-to-b from-emerald-400 to-emerald-600 flex items-center justify-center shadow-[0_0_60px_rgba(16,185,129,0.5)]"
        >
          <CheckCircle size={54} weight="fill" color="#fff" />
        </motion.div>
      </div>
      <motion.h3
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="font-display font-black text-2xl sm:text-3xl mt-6 tracking-tight"
      >
        Pagamento aprovado!
      </motion.h3>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
        className="text-slate-300 text-sm sm:text-base mt-2"
      >
        {first ? `Obrigado, ${first}! ` : "Obrigado pela compra! "}
        {redirectUrl ? "Seu acesso já está liberado." : "Enviamos os detalhes para o seu e-mail."}
      </motion.p>

      {redirectUrl ? (
        <div className="mt-6">
          <div className="text-sm text-slate-400" data-testid="redirect-countdown">
            Redirecionando você em <b className="text-[#FFB30F] tabular-nums">{Math.max(left, 0)}s</b>…
          </div>
          <div className="mt-3 h-1.5 rounded-full bg-white/10 overflow-hidden">
            <motion.div
              className="h-full bg-gradient-to-r from-[#FFB30F] to-[#ffd36b]"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: seconds, ease: "linear" }}
            />
          </div>
          <a href={redirectUrl} className="vb-cta mt-6" data-testid="payment-redirect-now-btn">
            Acessar agora <ArrowRight size={20} weight="bold" />
          </a>
        </div>
      ) : (
        <div className="mt-6 inline-flex items-center gap-2 text-sm text-slate-300 px-4 py-2.5 rounded-xl bg-white/5 border border-white/10">
          <EnvelopeSimple size={16} /> Confira sua caixa de entrada
        </div>
      )}
    </div>
  );
};
